const About = ({scrollToForm}) => {
    return (
        <>
            <section className="int_about_section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5" data-sal="slide-up" data-sal-duration="1000">
                            <div className="about_img_wrapper">
                                <img src="/assets/img/int_about_img.webp" alt="int_about_image" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about_content_wrapper mt-3 mt-lg-0">
                                <h2 className="section-title text-capitalize text-start" data-sal="slide-up" data-sal-duration="1000">Lifeline Tulasi Hospital</h2>
                                <p className="section-subtitle text-start" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="100">Excellence in Global Healthcare</p>
                                <p className="int_about_para" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">At Lifeline Tulasi Hospital, we are committed to delivering exceptional medical care
                                to patients from around the globe. With cutting-edge technology,
                                internationally trained specialists, and patient-centric services, we ensure a
                                seamless healthcare experience tailored to your needs. From initial
                                consultation to treatment and recovery, our dedicated International Patient
                                Services Team provides personalized assistance, travel support, and
                                comprehensive medical care to make your journey stress-free.</p>
                                <button onClick={scrollToForm} className="about-btn" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300">
                                    Book an Appointment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;